export default "__VITE_ASSET__dbebcf3a__"